import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { IAppState } from '../../store/state';
import { selectToken } from '../../store/selectors';

/**
 * Aplica `Authorization: Bearer <token>` em toda requisição HTTP — só
 * quando o request ainda não define um `Authorization` próprio (ex.:
 * AdministradoraService/AuthService já mandam o `partnerToken` explicitamente
 * para os endpoints que exigem, que não deve ser sobrescrito por esse
 * interceptor).
 *
 * REMOVIDO em 26/08/2026 um header `tenant: <slug>` que esse interceptor
 * mandava antes em TODA requisição — era um palpite nunca confirmado (nome
 * do header inventado, sem evidência nenhuma). Comparando byte a byte o
 * `LoginExterno` do nosso esqueleto local com o do app real (mesmo CPF,
 * mesma senha, ambos contra homologação): o CORPO da requisição batia
 * 100%, mas o nosso retornava "Usuário sem permissão de acesso" e o real
 * retornava sucesso — a única diferença possível eram os headers, e esse
 * `tenant` extra é o único header que a gente inventava e o app real não
 * manda. Suspeita principal, ainda sendo validada.
 * TODO: se ainda houver alguma diferença de comportamento entre tenants,
 * pode ser necessário reintroduzir ALGUM mecanismo de identificação de
 * tenant nos headers — mas com o nome/formato confirmado, não um palpite.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private store: Store<IAppState>) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.store.select(selectToken).pipe(
      take(1),
      switchMap((token) => {
        let req = request;
        if (token && !req.headers.has('Authorization')) {
          req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
        }
        return next.handle(req);
      })
    );
  }
}
